import { SECCION_TIPOS, getSeccionTipoLabel } from '../../constants/seccionTipos'

export const formatearDuracion = (totalSeg) => {
  if (!totalSeg || totalSeg <= 0) return '0min'
  const horas = Math.floor(totalSeg / 3600)
  const minutos = Math.floor((totalSeg % 3600) / 60)
  if (horas > 0 && minutos > 0) return `${horas}h ${minutos}min`
  if (horas > 0) return `${horas}h`
  return `${minutos}min`
}

export const agruparPorTipo = (secciones = []) => {
  const map = new Map()
  let totalReal = 0
  for (const sec of secciones) {
    const duracion = sec.fue_saltada ? 0 : (sec.duracion_real_seg || 0)
    totalReal += duracion
    if (!map.has(sec.tipo)) {
      map.set(sec.tipo, { tipo: sec.tipo, label: getSeccionTipoLabel(sec.tipo), duracionReal: 0 })
    }
    map.get(sec.tipo).duracionReal += duracion
  }

  const grupos = Array.from(map.values()).map((g) => ({
    ...g,
    porcentaje: totalReal > 0 ? Math.round((g.duracionReal / totalReal) * 100) : 0
  }))

  return grupos.sort((a, b) => b.duracionReal - a.duracionReal)
}

export const calcularResumen = (recorrido) => {
  const secciones = recorrido?.secciones || []
  const saltadas = secciones.filter((s) => s.fue_saltada)
  const extendidas = secciones.filter((s) => s.fue_extendida && !s.fue_saltada)
  const diferenciaPlaneadoSeg =
    (recorrido?.duracion_total_real_seg || 0) - (recorrido?.duracion_total_planeada_seg || 0)

  return {
    saltadas,
    extendidas,
    diferenciaPlaneadoSeg
  }
}

export { SECCION_TIPOS, getSeccionTipoLabel }
